import typing from './typing';
import Constants from '../constants/Constants';
import AuthService from '../services/AuthService';

class ajax {

    static get(url, options) {

        options = options || {};

        if (options.requestData) {
            url = this._getUrlFromRequestData(url, options.requestData);
        }

        let sendRequest = function (url, options, retryNumber) {

            let auth = new AuthService();

            const xhttp = new XMLHttpRequest();
            xhttp.onreadystatechange = function () {
                if (this.readyState === 4 && this.status === 200) {
                    const rawResponse = JSON.parse(this.responseText);
                    let response;

                    if (rawResponse.Content) {
                        response = JSON.parse(rawResponse.Content);
                    }
                    else {
                        response = rawResponse;
                    }

                    if (response.success && options.success) {
                        options.success(response);
                    }
                    else if (!response.success) {
                        if (options.error) {
                            options.error(response.error);
                        }
                        else {
                            console.error(`Error calling ${url} : ${response.error}`);
                            if (retryNumber < Constants.MAX_AJAX_CALLING_RETRIES) {
                                retryNumber++;
                                return sendRequest(url, options, retryNumber);
                            }
                        }
                    }
                }
                else if (this.readyState === 4 && this.status >= 400) {

                    if (this.status === 401) {
                        window.sessionStorage.clear();
                        localStorage.clear();
                        window.location.reload();
                    }
                    else if (options.error) {
                        options.error(this.responseText);
                    }
                    else if (retryNumber < Constants.MAX_AJAX_CALLING_RETRIES) {
                        retryNumber++;
                        return sendRequest(url, options, retryNumber);
                    }
                    else {
                        ajax._manageErrorHttp(this, url, 'GET');
                    }
                }
            };

            let async = true;
            if (options.async)
                async = options.async;

            xhttp.open("GET", url, async);

            if (auth.loggedIn()) {
                xhttp.setRequestHeader('Authorization', 'Bearer ' + auth.getToken());
            }

            xhttp.send();

            return xhttp;
        }

        return sendRequest(url, options, 1);

    }

    static put(url, options) {
        options = options || {};
        this._sendInBody(url, options, "PUT", 1);
    }

    static post(url, options) {
        options = options || {};
        this._sendInBody(url, options, "POST", Constants.MAX_AJAX_CALLING_RETRIES); // to avoid the creation of 3 entities if it fails in the middle of the procedure
    }

    static delete(url, options) {
        options = options || {};
        this._sendInBody(url, options, "DELETE", 1);
    }

    static _sendInBody(url, options, verb, retryNumber) {
        const self = this;

        let auth = new AuthService();

        const xhttp = new XMLHttpRequest();
        xhttp.onreadystatechange = function () {
            if (this.readyState === 4 && this.status === 200) {
                const rawResponse = JSON.parse(this.responseText);
                let response;
                if (rawResponse.Content) {
                    response = JSON.parse(rawResponse.Content);
                }
                else if (rawResponse.result) {
                    response = rawResponse;
                }
                else {
                    response = rawResponse;
                }

                if (response.success) {
                    if (options.success) {
                        options.success(response);
                    }
                }
                else if (options.error) {
                    options.error(response.error);
                }
                else if (retryNumber < Constants.MAX_AJAX_CALLING_RETRIES) {
                    retryNumber++;
                    self._sendInBody(url, options, verb, retryNumber);
                }
                else if (!response.success) {
                    console.error(`Error calling ${url} : ${response.error}`);
                }
            }
            else if (this.readyState === 4 && this.status >= 400) {
                if (this.status === 401) {
                    window.location.href = `/user/login?returnurl=${encodeURIComponent(window.location.href)}`;
                }
                else if (options.error) {
                    options.error(this.responseText);
                }
                else if (retryNumber < Constants.MAX_AJAX_CALLING_RETRIES) {
                    retryNumber++;
                    self._sendInBody(url, options, verb, retryNumber);
                }
                else {
                    ajax._manageErrorHttp(this, url, verb);
                }
            }
        };

        let async = true;
        if (options.async)
            async = options.async;

        const contentType = options.contentType || 'application/json';

        xhttp.open(verb, url, async);

        if (auth.loggedIn()) {
            xhttp.setRequestHeader('Authorization', 'Bearer ' + auth.getToken());
        }

        xhttp.setRequestHeader('Content-Type', contentType);
        xhttp.send(JSON.stringify(options.requestData));
    }


    //?data.PRODUCTTITLE=water&data.ORDERBY=IDCONTENT%20ASC
    static _getUrlFromRequestData(url, requestData) {
        if (requestData) {
            for (let field in requestData) {
                let appendChar = "?";
                if (url.includes("?")) {
                    appendChar = "&";
                }

                if (!typing.isEmpty(requestData[field]) && Object.prototype.toString.call(requestData[field]) === "[object Array]") {
                    for (let i = 0; i < requestData[field].length; i++) {
                        url += appendChar;

                        if (Object.prototype.toString.call(requestData[field][i].value) === "[object Array]") {
                            //url += field + '[' + i + '][key]=' + requestData[field][i].key;

                            //for (let x = 0; x < requestData[field][i].value.length; x++) {
                            //    url += '&' + field + '[' + i + '][value]=' + this._getValueForApi(requestData[field][i].value[x]);
                            //}

                            //if (requestData[field][i].value.length == 1) //HACK, sent it twice to let .Net know it is a list
                            //{
                            //    url += '&' + field + '[' + i + '][value]=' + this._getValueForApi(requestData[field][i].value[0]);
                            //}
                        }
                        else {
                            url += field + '.' + requestData[field][i].key + '=' + + this._getValueForApi(requestData[field][i].value);
                        }

                        //if (Object.prototype.toString.call(requestData[field][i].value) === "[object Array]") {
                        //    url += field + '[' + i + '][key]=' + requestData[field][i].key;

                        //    for (let x = 0; x < requestData[field][i].value.length; x++) {
                        //        url += '&' + field + '[' + i + '][value]=' + this._getValueForApi(requestData[field][i].value[x]);
                        //    }

                        //    if (requestData[field][i].value.length == 1) //HACK, sent it twice to let .Net know it is a list
                        //    {
                        //        url += '&' + field + '[' + i + '][value]=' + this._getValueForApi(requestData[field][i].value[0]);
                        //    }
                        //}
                        //else {
                        //    url += field + '[' + i + '][key]=' + requestData[field][i].key + '&' + field + '[' + i + '][value]=' + this._getValueForApi(requestData[field][i].value);
                        //}

                        if (appendChar === "?") {
                            appendChar = "&";
                        }
                    }
                }
                else if (!typing.isEmpty(requestData[field]) && typeof requestData[field] === "object" && !typing.isDate(requestData[field])) {

                    for (let insideField in requestData[field]) {

                        if (!url.endsWith(appendChar)) {
                            url += appendChar;
                        }

                        if (Object.prototype.toString.call(requestData[field][insideField]) === "[object Array]") {
                            //url += field + '[' + insideCounter + '][key]=' + insideField;

                            url += field + '.' + insideField + '=';// 

                            for (let i = 0; i < requestData[field][insideField].length; i++) {
                                //url += '&' + field + '[' + insideCounter + '][value]=' + this._getValueForApi(requestData[field][insideField][i]);
                                url += this._getValueForApi(requestData[field][insideField][i]);
                            }

                            if (requestData[field][insideField].length === 1) //HACK, sent it twice to let .Net know it is a list
                            {
                                url += field + '.' + insideField + '=' + this._getValueForApi(requestData[field][insideField][0]);
                            }
                        }
                        else if (requestData[field][insideField] || requestData[field][insideField] === 0 || requestData[field][insideField] === false) {
                            //url += field + '[' + insideCounter + '][key]=' + insideField + '&' + field + '[' + insideCounter + '][value]=' + this._getValueForApi(requestData[field][insideField]);
                            url += field + '.' + insideField + '=' + this._getValueForApi(requestData[field][insideField]);
                        }

                        if (requestData[field][insideField] || requestData[field][insideField] === 0 || requestData[field][insideField] === false) {
                            if (appendChar === "?") {
                                appendChar = "&";
                            }
                        }
                    }
                }
                else if (!typing.isEmpty(requestData[field])) {
                    url += appendChar + field + "=" + this._getValueForApi(requestData[field]);
                }
            }
        }
        return url;
    }

    static _getValueForApi(originalValue) {
        if (typing.isDate(originalValue)) {
            return `${originalValue.getFullYear()}-${(originalValue.getMonth() + 1)}-${originalValue.getDate()}`;
        }
        else {
            return originalValue;
        }
    }

    static _manageErrorHttp(response, url, verb) {
        let text = `Error calling: ${url} \nVerb: ${verb}\nStatus code: ${response.status}`
        if (response.responseText) {
            text += '\n' + response.responseText;
        }
        console.error(text);
        throw text;
    }
};

export default ajax;

